{
  "translation": {
    "button": {
      "ok": "Ok",
      "cancel": "Cancel",
      "login": "Login",
      "logout": "Logout",
      "save": "Save",
      "manageoptions": "Manage Options",
      "manageproduct": "Manage Product",
      "resetAll": "Reset All to Product Values",
      "revert": "Revert",
      "statusButton": "Active/InActive",
      "add": "Add",
      "selectCategory": "Select Category",
      "close": "Close",
      "publish": "Publish",
      "publishProductData": "Publish Product Data (In Flight)",
      "new": "New",
      "delete": "Delete",
      "refresh": "Refresh",
      "create": "Create",
      "proCosExport": "ProCos Export",
      "pcsExport": "PCS Export",
      "submit": "Submit"
    },
    "tooltip": {
      "edit": "Edit",
      "view": "View",
      "reset": "Reset",
      "publishProductDataEnabled": "Data present as part of the Master and published will be shared.",
      "publishProductDataDisabled": "Disabled as the product is inactive in Master."
    },
    "footer": {
      "env": "Env",
      "release": "R",
      "sprint": "SP",
      "build": "Build",
      "branch": "Branch",
      "date": "Date"
    },
    "labels": {
      "selectCategoryType": "Select a category type",
      "searchMultiNumericCategory": "Search Multi-Numeric Category",
      "addCategory": "Add Category",
      "search": "Search",
      "recordsPerPage": "Records",
      "workItem": "WorkItem",
      "searchproduct": "Search Product",
      "language": "Select Language",
      "failedRules": "Failed Rules",
      "feature": "Feature",
      "option": "Option",
      "type": "Type",
      "reset": "Reset to Product values",
      "flag": "Flag",
      "code": "Code",
      "country": "Country",
      "quote": "RFQ",
      "quoteSymbol": "Q",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "masterProperties": "Master Properties",
      "productProperties": "Product Properties",
      "status": "Status",
      "saveStatus": "Save",
      "categories": "Categories",
      "unassigned": "Unassigned",
      "assigned": "Assigned",
      "defaultAssignment": "Assigned by Default",
      "refresh": "Refresh",
      "procos": "ProCoS",
      "pdm": "PDM",
      "product": "Product",
      "RuleCreationFailed": "All Rule creation failed.",
      "manage": "Manage",
      "multiNumeric": "Multi-Numeric",
      "multiNumericManagement": "MultiNumeric Management",
      "yes": "Yes",
      "no": "No",
      "isActive": "Active",
      "isLocal": "Is Local",
      "name": "Name",
      "standard": "Standard",
      "others": "Others",
      "multiNumericAction": "{{Action}} MultiNumeric Feature",
      "createdOn": "Created On",
      "modifiedOn": "Modified On",
      "createdBy": "Created By",
      "modifiedBy": "Modified By",
      "active": "Active",
      "inActive": "InActive",
      "propertyCode": "Property Code",
      "associationType": "Association Type",
      "featureCode": "Feature Code",
      "optionCode": "Option Code",
      "action": "Action",
      "oldValue": "Old Value",
      "newValue": "New Value",
      "startDate": "Start Date",
      "endDate": "End Date",
      "history": "History",
      "properties": {
        "ACO": "Alternative Code",
        "AGC": "Article Group",
        "ASC": "Associated Codes",
        "CHT": "Channel Type",
        "CON": "Consumer",
        "DVI": "Delivery Via",
        "GRD": "Is Guarded",
        "HDE": "Hide",
        "ICO": "Catalog Child Only",
        "IPR": "Is Price Relevant",
        "ITY": "Item Type",
        "MLE": "Max Length",
        "OPT": "Is Optional",
        "ORI": "Ordering Instructions",
        "PAT": "Product Arche Type",
        "PCFD": "Print On CFD",
        "PMA": "ProCos Market Availability",
        "RCI": "Release Catalog Identifier",
        "REO": "Is Read Only",
        "RMA": "Rules Market Available",
        "RTY": "Reference Type",
        "SCN": "SAP Characteristic Name",
        "SCV": "SAP Characteristic Value",
        "SRI": "Is Service Relevant",
        "ERO": "Engineering Responsibility Organization (ERO)"
      },
      "columns": "Columns",
      "filters": "Filters",
      "selectAll": "Select All",
      "consumers": "Consumers"
    },
    "home": {
      "header": "Product Model Selection"
    },
    "dialogBox": {
      "error": "Error",
      "save": "Save",
      "reset": "Reset",
      "revert": "Revert",
      "unsavedChanges": "Warning - Unsaved Changes",
      "delete10Items": "Only 10 records can be deleted at a time",
      "success": "Success",
      "confirm": "Confirm {{action}}"
    },
    "messages": {
      "logoutMessage": "User is logged out. Please login to the application again.",
      "unauthenticated": "User is not logged in. Please login. If problem persists, please contact your administrator.",
      "browserNotSupported": "Browser not supported",
      "browserNotSupportedMessage": "You are using a browser or browser version that is not officially supported.<1/><1/>You can continue to use the application or use one of the latest version of the supported browser for best experience.",
      "supportedBrowsers": "Supported browsers: ",
      "errorTitle": "Error",
      "codeErrorMessage": "Please Enter Valid Code",
      "nameErrorMessage": "Please Enter Valid Name",
      "downloadMessage": "{{filename}} has been successfully downloaded",
      "noSearchRecords": "No records found for '{{searchValue}}'",
      "noDataFound": "No Data found.",
      "noDataFoundforcriteria": "No data available for the specified criteria.",
      "pdm": {
        "noPropertiesFound": "No Properties found",
        "noPropertyAssociationFound": "No Property Associations found."
      },
      "feature": {
        "confirmDelete": "Are you sure you want to delete?"
      },
      "category": {
        "selectCategory": "Please select a category",
        "categoryAlreadyExist": "Sequence or Category already exist",
        "confirm": "Confirm",
        "confirmDelete": "Are you sure you want to delete the category?",
        "confirmCleanEmptySection": "Sections without feature will be removed.",
        "unsavedChanges": "Warning - Unsaved Changes",
        "discardChanges": "Unsaved changes will be discarded, do you want to proceed?",
        "savedSuccessfully": "Master view saved successfully.",
        "noFeatureAssigned": "No feature's assigned !",
        "saveToremoveObsoleteFeature": "There are Obsolete features and he has to save",
        "multiNumericWarning": "Only Numeric feature families can be added.",
        "multiNumericReadError": "Feature not found",
        "multiNumericMinValidationError": "Min. {{minLength}} characters required",
        "multiNumericMaxValidationError": "Max. {{maxLength}} characters allowed.",
        "searchLimitWarning": "{{limit}}/{{total}} results are shown. Refine the search criteria to narrow on the results",
        "inValidCategoryDrag": "Cannot drop to this position"
      },
      "error": {
        "403": "You dont have access. Please contact administrator.",
        "ERR_NETWORK": "Network error: request could not be processed, try saving the data again.",
        "WiInvalid": "The Selected WorkItem is Invalid! Please select another workitem or create a new workitem.",
        "invalidWorkItemId": "Invalid workItemId: Must be a number >= 1",
        "E_RUL_VAL_101": "ProCos data not found ",
        "E_PRD_VAL_101": "Invalid consumers: {{consumers}} ",
        "fetchPropertyAssociations": "Some error occured. Unable to fetch property associations!"
      },
      "http": {
        "400": "Invalid data.",
        "401": "Your session has expired. Please re-login.",
        "403": "You don't have access. Please contact administrator.",
        "404": "Resource not found.",
        "204": "No changes to save.",
        "500": "Some error occurred. Please try again later."
      },
      "submit": {
        "general": "Changes are saved successfully!",
        "new": "Do you wish to save ProCoS information to <1>New Work Item</1> ?",
        "exist": "Do you wish to save ProCoS information to the WorkItem - <1>{{workItemName}} </1> ?",
        "allMarketsRemoved": "Use 'Status' dropdown to mark the product as InActive.",
        "success": "Changes saved successfully to WorkItem - <1>{{workItemName}} </1>",
        "error": "Save Failed !",
        "reset": "Do you wish to reset the ProCos of Feature/Option with product level ProCos?",
        "resetAll": "Do you wish to reset the ProCos of all Features/Options with product level ProCos?",
        "revert": "Do you wish to revert your changes to current Workitem - <1>{{workItemName}} </1> ?",
        "failedEffectivities": "Failed (Active / InActive): Following feature / options could not be processed.",
        "AllEffectivityFailed": "All effectivity update failed.",
        "RulesSaved": "Rules saved successfully.",
        "EffectivitySaved": "Effectivity saved successfully.",
        "DeleteRequest": "Delete Request Failed",
        "DeleteRequestSuccess": "Successfully deleted ({{length}}) multiNumeric feature(s) : {{list}}"
      },
      "cancel": {
        "workitemWarning": "Are you sure you want to switch to the Work Item - <1>{{workItemName}} </1> ?",
        "homeWarning": "Are you sure you want to navigate from this page?",
        "featureChangeWarning": "Are you sure you want to switch to another feature?",
        "undoPropAssociationWarning": "Are you sure you want to undo your changes?"
      },
      "refresh": "Your current changes will be lost on refresh. Do you wish to proceed?",
      "inActiveProduct": {
        "header": "Product Inactive",
        "message": "No market association changes allowed"
      },
      "saveProcos": {
        "rulesFailedTopic": "Processing Failed",
        "rulesFailed": "Page {{pageNo}} : {{rule}} Rules <ruleIcon/>, {{property}} Properties <propertyIcon/>",
        "batchStatus": "SaveProCos - {{completedBatchesCount}} batch(es) completed out of {{totalBatchCount}} batch(es).",
        "batchSuccess": "All batch(es) succeeded",
        "batchFailed": "All batch(es) failed",
        "batchPartialSuccess": "One or more batches failed"
      },
      "success": {
        "create": "Created successfully!",
        "update": "Updated successfully!"
      },
      "fail": {
        "create": "Creation failed!",
        "update": "Updation failed!",
        "get": "Some error occured. Unable to fetch details!"
      },
      "validation": {
        "enumInvalid": "One or more property values are invalid (highlighted in red). Please correct them before saving."
      }
    },
    "request": {
      "success": "Request placed successfully",
      "failed": "Request  failed"
    }
  }
}
